import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Input,
  Text,
  Textarea,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { FiPaperclip, FiSmile, FiTrash2 } from "react-icons/fi";
import { Context } from "./store";
// import EmojiPicker from 'emoji-picker-react';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import styles from "../style/timeline.module.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Auth } from "./Auth";
import { useContext } from "react";
const Timeline = ({ text, orderData, tenureData, orderName }) => {
  
  const [comment, setComment] = useState({ msg: "" });
  const [timelineHistory, setTimelineHistory] = useState([]);
  const { id } = useParams();
  
  const { userData } = useContext(Context);
  const uploadFiles = () => {
    //implement here
  };
  // const addEmoji = () => {
  //     // implement here
  // }
  // const onEmojiClick = (e, emojiObject) => {
  //     setComment(...comment, emojiObject.emoji)
  // }
  const onChange = (e) => {
    setComment({ ...comment, [e.target.name]: e.target.value });
  };
  const boxStyle = {
    margin: "0",
    marginLeft: "60px",
    padding: "0",
    border: "none",
    background: "none",
    display: "block",
    borderRadius: "none",
    boxShadow: "unset",
  };
  const iconStyles = {
    background: "rgb(131,133,135)",
    width: "15px",
    height: "15px",
    left: "16.2px",
    top: "24.5px",
    boxShadow: "unset",
    zIndex: 1,
  };
  const avatarTimeline = {
    content: "''",
    position: "absolute",
    width: "1px",
    backgroundColor: "rgb(184,187,190)",
    top: "47px",
    bottom: "0",
    left: "55%",
    marginLeft: "-3px",
    height: "78%",
  };


  const fetchTimelineHistory = async () => {
    
    let data = JSON.stringify({
      orderId: `${id}`,
    });

    if (!id) {
      data = JSON.stringify({
        orderId: orderData?.id,
      });
    }

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/status/history`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        let th = response.data.sort((a, b) => {
          const dateA = new Date(a.cratedAt);
          const dateB = new Date(b.cratedAt);

          if (dateA > dateB) {
            return -1;
          }

          if (dateA < dateB) {
            return 1;
          }

          return 0;
        });

        setTimelineHistory(th);
      })
      .catch((error) => {
        console.log(error);
      });
    }

  // Timeline history api
  useEffect(() => {
    fetchTimelineHistory()
    // let data = JSON.stringify({
    //   orderId: `${id}`,
    // });

    // let config = {
    //   method: "post",
    //   maxBodyLength: Infinity,
    //   url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/status/history`,
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: Auth(),
    //   },
    //   data: data,
    // };

    // axios
    //   .request(config)
    //   .then((response) => {
    //     // console.log(JSON.stringify(response.data));
    //     let th = response.data.sort((a, b) => {
    //       const dateA = new Date(a.cratedAt);
    //       const dateB = new Date(b.cratedAt);

    //       if (dateA > dateB) {
    //         return -1;
    //       }

    //       if (dateA < dateB) {
    //         return 1;
    //       }

    //       return 0;
    //     });

    //     setTimelineHistory(th);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }, [id, orderData]);

  // Sorting Date & time
  const dateToTime = (date) => {
    const dateObj = new Date(date);
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();

    let period = "AM";
    let adjustedHours = hours;

    if (hours >= 12) {
      period = "PM";
      adjustedHours = hours === 12 ? 12 : hours - 12;
    }

    const time = `${adjustedHours}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;
    return time;
  };
  // checking is today
  const isDateEqual = (date) => {
    // Get today's date
    let todaysDate = new Date();

    // call setHours to take the time out of the comparison
    if (date.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0)) {
      // Date equals today's date
      return true;
    }
  };

  const [addingComment, setAddingComment] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);
  const cancelRef = React.useRef();

  const addComment = async (comment) => {
    setAddingComment(true);
    const url = "/status/history/comment";
    
    const data = JSON.stringify({
      orderId: id || orderData?.id,
      comment: comment.msg,
      changeByPartyId: userData?.id,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/status/history/comment`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then(async (response) => {
        console.log(JSON.stringify(response.data));
        await fetchTimelineHistory()
        setComment({ ...comment, msg: "" });
      })
      .catch((error) => {
        console.log(error);
      });
    setAddingComment(false);
  };

  const deleteComment = async (commentId) => {
    try {
      const config = {
        method: "delete",
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/order-status-history/${commentId}`,
        headers: {
          Authorization: Auth(),
        },
      };

      await axios.request(config);
      await fetchTimelineHistory();
      setIsDeleteDialogOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteClick = (commentId) => {
    setCommentToDelete(commentId);
    setIsDeleteDialogOpen(true);
  };

  return (
    <Box my={5} p={3}>
      <Heading size={"md"} mb={2}>
        Timeline
      </Heading>
      <Divider size={1} my={2} borderBottomColor={"black"} />
      <Box my={3} w={"full"}>
        <Flex w={"full"} h={"190px"}>
          <Box position={"relative"} _after={avatarTimeline}>
            <Avatar name="Angad Sharma" src="#" />
          </Box>
          <Box ml={3} w={"full"}>
            <Box
              bgColor={"#FFFFFF"}
              shadow={"md"}
              rounded={"md"}
              border={"1px"}
              borderColor={"gray.200"}
            >
              <Box width={"full"}>
                <Textarea
                  resize={"none"}
                  name="msg"
                  rows={1}
                  p={3}
                  size={"md"}
                  placeholder="Leave a comment"
                  value={comment.msg}
                  onChange={onChange}
                />
              </Box>
              <Flex justifyContent={"space-between"} p={3}>
                <Flex>
                  <Box>
                    <Button
                      bgColor={"transparent"}
                      _hover={{ bgColor: "transparent" }}
                      p={0}
                    >
                      <FiSmile />
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      bgColor={"transparent"}
                      _hover={{ bgColor: "transparent" }}
                      p={0}
                      onClick={uploadFiles}
                    >
                      <FiPaperclip />
                    </Button>
                    <Input id="selectFile" type={"file"} display={"none"} />
                  </Box>
                </Flex>
                <Button
                  size={"md"}
                  bgColor={"gray.400"}
                  isLoading={addingComment}
                  disabled={addingComment}
                  onClick={() => addComment(comment)}
                >
                  Post
                </Button>
              </Flex>
            </Box>
            <Text textAlign={"right"} my={2} fontSize={"xs"}>
              {text}
            </Text>
            {/* <Box id='emojiPicker' display={'none'} position={'relative'} zIndex={25}>
                            <EmojiPicker onEmojiClick={onEmojiClick} autoFocusSearch={false} previewConfig={{}} />
                        </Box> */}
          </Box>
        </Flex>
        {/* -------------------- Timeline ------------------------ */}
        <Box>
          <VerticalTimeline
            animate={false}
            layout={"1-column-left"}
            lineColor="#000"
            className={styles.line}
          >
            {timelineHistory.map((x, i) => {
              let content = "";
              switch (`${x.orderStatusToId}`) {
                case "AWAITING_VERIFICATION":
                  content = `${
                    orderData.customerParty?.firstName +
                    " " +
                    orderData.customerParty?.lastName
                  } placed an order for ${orderData?.OrderItem.map(
                    (z) => z.title + ", "
                  )}  (Order ID - ${
                    orderName.includes("#")
                      ? orderName
                      : orderName.includes("-")
                      ? orderName.split("-")[4]
                      : orderName
                  })`;
                  break;
                case "ORDER_VERIFIED":
                  content = "Order verified successfully";
                  break;
                case "ORDER_OUT_FOR_DELIVERY":
                  content =
                    "Order has been assigned and picked up by Delivery Boy";
                  break;
                case "ORDER_DELIVERED":
                  content = `Order Delivered to ${
                    orderData.customerParty?.firstName +
                    " " +
                    orderData.customerParty?.lastName
                  }`;
                  break;
                case "ORDER_CANCELED":
                  content = "Order Cancelled";
                  break;
                case "ORDER_PUBLISHED":
                  content = "Order Published";
                  break;
                case "ORDER_DRAFT":
                  content = "Order Draft";
                  break;
                case "ORDER_CREATED":
                  content = "Order Created";
                  break;
                case "ORDER_COMMENTED":
                  content = x.comment;
                  break;
                default:
                  content = "----";
                  console.log("error");
              }
              const previousItem = timelineHistory[i - 1];

              // Check if previousItem exists and its date is equal to the current date
              const isPreviousDateEqual =
                previousItem &&
                new Date(previousItem.cratedAt).toLocaleDateString("en-IN", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                }) ===
                  new Date(x.cratedAt).toLocaleDateString("en-IN", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  });

              return (
                <VerticalTimelineElement
                  key={x.id}
                  className={styles.container}
                  contentStyle={boxStyle}
                  contentArrowStyle={{ display: "none" }}
                  iconStyle={iconStyles}
                >
                  <Flex justifyContent={"space-between"}>
                    <Box flexBasis={"70%"}>
                      <Heading as="h6" h={"18px"} size="sm">
                        {isDateEqual(new Date(x.cratedAt))
                          ? i === 0
                            ? "Today"
                            : null
                          : !isPreviousDateEqual
                          ? new Date(x.cratedAt).toLocaleDateString("en-IN", {
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            })
                          : null}
                      </Heading>

                      {x.orderStatusToId === "ORDER_COMMENTED" ? (
                        <div style={{ backgroundColor: '#f8f9fa', padding: '8px', borderRadius: '4px', position: 'relative' }}>
                          <Flex justifyContent="space-between" alignItems="center">
                            <Text as={"span"}>
                              {x.changeByParty?.firstName}{" "}
                              {x.changeByParty?.lastName} commented
                            </Text>
                            
                              <Button
                                size="sm"
                                variant="ghost"
                                colorScheme="red"
                                onClick={() => handleDeleteClick(x.id)}
                              >
                                <FiTrash2 size={14} />
                              </Button>
                            
                          </Flex>
                          <Text as={"span"} color="red.600" fontWeight="bold">{content}</Text>
                        </div>
                      ) : (
                        <Text as={"span"} color="gray.600">{content}</Text>
                      )}
                    </Box>
                      
                    <Flex alignItems={"end"}>
                      <Text as={"span"}>{dateToTime(x.cratedAt)}</Text>
                    </Flex>
                  </Flex>
                </VerticalTimelineElement>
              );
            })}
          </VerticalTimeline>
        </Box>
      </Box>
      <AlertDialog
        isOpen={isDeleteDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Comment
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this comment? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsDeleteDialogOpen(false)}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => deleteComment(commentToDelete)}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default Timeline;
